// extracted by mini-css-extract-plugin
export var cardHeader = "_jo-0";
export var reorderHandle = "_jo-3";
export var titleArea = "_jo-1";
export var titleAreaWithHandle = "_jo-2";